import styled from 'styled-components';
  
export const Container = styled.div`
   display: flex;
   align-items: left;
   font-size: 30px;
   width: 300px;
   height: 50px;
    margin-top: 30px;
    margin-left: 10%;
    margin-bottom: 30px;
    padding: 10px;
    letter-spacing: 1px;
`
export const Radio = styled.input`
   display: none;
`
export const Rating = styled.div`
   cursor: pointer;
`
